import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function LocationInfo() {
  const { t } = useLanguage();
  const [showQR, setShowQR] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  
  return (
    <section className="w-full bg-white min-h-screen flex flex-col md:flex-row items-stretch justify-center gap-0 md:gap-0 px-0 md:px-0">
      {/* Map */}
      <div className="md:w-1/2 w-full h-[220px] sm:h-[320px] md:h-auto flex items-stretch justify-stretch">
        <iframe
          title="Azure Loft Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3253.5928883772044!2d25.017395775353737!3d35.36574844724056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x149a51001c9c8e3b%3A0xc5aa58d7b50160ca!2sAzure%20Loft!5e0!3m2!1sel!2sgr!4v1751039945678!5m2!1sel!2sgr"
          width="100%"
          height="100%"
          style={{ border: 0, borderRadius: '0', minHeight: 180, height: '100%' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      {/* Info */}
      <div className="w-full flex flex-col justify-center items-center bg-white rounded-2xl shadow-lg p-4 sm:p-8 border border-gray-100 text-center max-w-[1200px] mx-auto">
        <h1 className="text-2xl sm:text-4xl md:text-6xl font-extrabold mb-0 text-center pt-0" style={{ fontWeight: 700, fontFamily: 'Caveat, Poppins, Montserrat, Inter, sans-serif', letterSpacing: '0.04em', color: '#6ee7b7' }}>
          {t('location.title')}
        </h1>
        <h3
          className="text-lg sm:text-2xl md:text-3xl font-semibold mb-2 sm:mb-4 text-center"
          style={{ fontFamily: 'Caveat, Poppins, Montserrat, Inter, sans-serif', color: '#bfa181' }}
        >
          {t('location.subtitle')}
        </h3>
        <div className="mt-2 text-base sm:text-lg md:text-3xl lg:text-3xl text-gray-800 leading-relaxed font-medium text-center" style={{ fontFamily: 'Montserrat, Poppins, Inter, sans-serif', fontWeight: 500, color: '#222' }}>
          {t('location.description').split('\n\n').map((paragraph, index) => (
            <React.Fragment key={index}>
              <span dangerouslySetInnerHTML={{ __html: paragraph }} />
              {index < t('location.description').split('\n\n').length - 1 && <><br/><br/></>}
            </React.Fragment>
          ))}
        </div>
        {/* QR Code Button */}
        <div className="relative flex flex-col items-center w-full">
          <button
            className="mt-6 sm:mt-8 px-6 sm:px-10 py-3 sm:py-4 bg-emerald-400 hover:bg-emerald-500 text-lg sm:text-2xl font-extrabold rounded-full shadow-lg transition-colors duration-200 tracking-wide"
            style={{ letterSpacing: '0.04em' }}
            onClick={() => setShowQR(true)}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onFocus={() => setShowTooltip(true)}
            onBlur={() => setShowTooltip(false)}
          >
            QR CODE
          </button>
          {typeof showTooltip !== 'undefined' && showTooltip && (
            <div className="absolute -top-12 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-xs sm:text-base rounded-lg px-2 sm:px-4 py-1 sm:py-2 shadow-lg whitespace-nowrap z-10 animate-fade-in" style={{ pointerEvents: 'none' }}>
              Πάτησε για να εμφανιστεί ο QR code της τοποθεσίας
            </div>
          )}
        </div>
        {/* QR Modal */}
        {showQR && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            onClick={() => setShowQR(false)}
          >
            <div
              className="bg-white rounded-2xl p-2 sm:p-8 shadow-2xl relative flex flex-col items-center justify-center w-[90vw] max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl"
              style={{ minWidth: 0, minHeight: 0, maxWidth: '90vw', maxHeight: '80vh', width: '90vw', height: 'auto' }}
              onClick={e => e.stopPropagation()}
            >
              <button
                className="absolute top-2 right-4 text-gray-500 hover:text-gray-800 text-2xl sm:text-3xl font-bold"
                onClick={() => setShowQR(false)}
                aria-label="Close"
              >
                ×
              </button>
              <img
                src={process.env.PUBLIC_URL + '/azure_loft_map_qr.png'}
                alt="Azure Loft QR Code"
                className="object-contain"
                style={{ maxWidth: '80vw', maxHeight: '70vh', width: '100%', height: 'auto' }}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
} 